<div class="topDiv" [style.background-color]="backgroundColorScreen">

    <div class="agGridOuterDiv"  style="margin-top: 3%;">
      <div>

        <div class="row topRowMargins headerStyle">

          <div class="col-lg-12">
            Adhoc Reports
          </div>

        </div>

      </div>
        <mat-toolbar class="agGridtoperDiv card mattoolbar">


            <div class="mainContent">
                <form novalidate [formGroup]="FormValid">
                    <div class="row">

                        <div class="col-lg-3">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@TMSCHOOLFEESMASTERinstitutename">Select Date Type</mat-label>
                                <mat-select formControlName="date" (selectionChange)="ChangeSelect($event)"
                                    [(ngModel)]="date">
                                    <mat-option value="today">Today</mat-option>
                                    <mat-option value="currentWeek">Current Week</mat-option>
                                    <mat-option value="currentMonth">Current Month</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-3">
                            <mat-form-field appearance="outline">
                              <mat-label i18n="@@TMSTAFFMASTERLastname">Start Date</mat-label>
                              <input matInput [(ngModel)]="startDatetemp" [max]="endDateTemp" [matDatepicker]="startDate" readonly required
                                formControlName="startDate">
                              <mat-datepicker-toggle matSuffix [for]="startDate">
                                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                              </mat-datepicker-toggle>
                              <mat-datepicker #startDate></mat-datepicker>
                              <mat-error
                                *ngIf="FormValid.get('startDate').hasError('matDatepickerParse') && (FormValid.get('startDate').dirty || FormValid.get('startDate').touched)">
                                <span>Start Date is required</span>
                              </mat-error>
                              <mat-error
                                *ngIf="FormValid.get('startDate').hasError('required') && (FormValid.get('startDate').dirty || FormValid.get('startDate').touched)">
                                <span>Start Date is required</span>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-lg-3">
                            <mat-form-field appearance="outline">
                              <mat-label>End Date</mat-label>
                              <input matInput [matDatepicker]="dp3" [min]="startDatetemp" [(ngModel)]="endDateTemp"
                                formControlName="endDate"readonly required>
                              <mat-datepicker-toggle matSuffix [for]="dp3">
                                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                              </mat-datepicker-toggle>
                              <mat-datepicker #dp3></mat-datepicker>
                              <mat-error
                                *ngIf="FormValid.get('endDate').hasError('matDatepickerParse') && (FormValid.get('endDate').dirty || FormValid.get('endDate').touched)">
                                <span>End Date is required</span>
                              </mat-error>
                              <mat-error
                                *ngIf="FormValid.get('endDate').hasError('required') && (FormValid.get('endDate').dirty || FormValid.get('endDate').touched)">
                                <span>End Date is required</span>
                              </mat-error>
                            </mat-form-field>
                          </div>

                        <div class="col-lg-2" style="display: flex;">
                            <div style="text-align: center;">
                            <button
                                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                style="margin-right:15px;padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;" [style.background-color]="backgroundColorButton"
                                (click)="senddata()">Run</button>
                            </div>
                            <div style="text-align: center;">
                                <button
                                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                style="margin-left:15px;padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;" [style.background-color]="backgroundColorButton"
                                (click)="clearData()" type="reset">Cancel</button>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </mat-toolbar>

        <div fxLayout="row">


          <div [fxFlex]="showMe ? '0px':'350px'" class="overflow-hidden" style="margin-right: 1%;">

              <mat-toolbar class="agGridtoperDiv card" style="
              background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
              border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;margin-left: 0%;">
                  <label i18n="@@spmsUserReg" class="textColour">Report Templates</label>

              </mat-toolbar>

          <ag-grid-angular class="ag-theme-balham table-width-reports tablestyles square scroolbar-dusty-grass square thin"
          [columnDefs]="columnDefsReports" [animateRows]="true" [pagination]="true"
          [rowSelection]="rowSelectionReports" [defaultColDef]="defaultColDefReports" [suppressPaginationPanel]="true" [rowHeight]="35"
          [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
          [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRulesReports" [gridOptions]="gridOptions"

          [components]="components"
          (gridReady)="onGridReadyReports($event)" (cellClicked)="getReportDetails($event)" [hidden]="!true"></ag-grid-angular>

        </div>


        <div  [fxFlex]="showMe ? '100%' : 'calc(100% - 550px)' " style="min-width: 0%;">
         <mat-toolbar class="agGridtoperDiv card" style="
              background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
      border-right: 1px solid #a9a9a9a8;
      border-left: 1px solid #a9a9a9a8;margin-right: 0%;">


           <label i18n="@@spmsUserReg" class="textColour">Generated Reports List</label>



                          <span class="example-spacer"></span>
                          <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">Download
                                  <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                          </button>
                          <div class="insertPageNoDiv">
                              <mat-form-field appearance="outline">
                                  <mat-label i18n="@@Targetpageno">Page No</mat-label>
                                  <input matInput type="text" (input)="onSearchChange($event.target.value)">
                              </mat-form-field>
                          </div>
                          <div class="selectRecordsDiv" style="width:9.5%">
                              <mat-form-field appearance="outline" style="width:100%">
                                  <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                                  <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged(value)">
                                      <mat-option value="10" selected>10</mat-option>
                                      <mat-option value="200">200</mat-option>
                                      <mat-option value="300">300</mat-option>
                                      <mat-option value="400">400</mat-option>
                                  </mat-select>

                              </mat-form-field>
                          </div>
                          <div class="card pagination paginationFirstButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                          </div>
                          <div class="card pagination paginationButtons btn-rounded">
                              <ul>
                                  <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                          (click)="onBtPrevious()"></em></li>
                                  <li>{{currentPage}}/{{totalPages}}</li>
                                  <li class="paginationliicon" style="padding:0;"><em
                                          class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                              </ul>
                          </div>
                          <div class="card pagination paginationLastButton paginationFirstlastButton">
                              <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                          </div>




          </mat-toolbar>

          <div style="margin-right:0%" >

            <ag-grid-angular class="ag-theme-balham table-width-screen tablestyles square scroolbar-dusty-grass square thin"
            (gridReady)="onGridReady($event)" [hidden]="!true"
            [columnDefs]="columnDefs" [animateRows]="true" [pagination]="true"
            [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
            [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
            [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
            [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
            (paginationChanged)="onPaginationChanged()" [components]="components"


            ></ag-grid-angular>

          </div>

        </div>


      </div>

    </div>
</div>
